export default __webpack_public_path__ + "static/media/Tarjetas_Albo.af0fe653.png";